import { addYears } from "date-fns";

export const getExpirationDate = (value: string | null): Date => value ? new Date(value) : addYears(new Date(), 1000);
